export default __webpack_public_path__ + "static/media/thumb.e9fb7132.png";